import React from 'react'
import { css } from '@emotion/react'

// import useSignup from '@src/hooks/auth/signup/useSignup'
import useSignupContext from '@src/hooks/auth/signup/useSignupContext'

import Input from '@src/components/inputs/Input'

const AccountInfoSection = () => {
	const { getFieldProps } = useSignupContext()

	return (
		<>
			<Input
				{...getFieldProps('username')}
				css={inputStyle}
				label="아이디"
				placeholder="아이디를 입력해주세요."
			/>
			<Input
				type="password"
				{...getFieldProps('password')}
				css={inputStyle}
				label="비밀번호"
				placeholder="비밀번호를 입력해주세요."
			/>
			<Input
				type="password"
				{...getFieldProps('passwordConfirm')}
				css={inputStyle}
				label="비밀번호 확인"
				placeholder="비밀번호를 재입력해주세요."
			/>
		</>
	)
}

const inputStyle = css`
	width: 27rem;
`

export default AccountInfoSection
